import * as React from 'react';

import { Props as RefundOrderStatusProps } from '../../../../../Refund/Components/OrderRefundStatus/OrderRefundStatus';
import { useExareInfoStatus } from '../../../../../Refund/Components/OrderRefundStatus/useExareInfoStatus';
import Notification, { Props as NotificationProps } from '../../../../../BaseComponents/Notification';
import cn from 'classnames';
import { useTheme } from '../../../../../theme';
import { format } from '../../../../../utils';
import { useTranslation } from 'react-i18next';
import { ExareStatus } from '@websky/graphql';

type Props = Omit<RefundOrderStatusProps, 'renderTitle' | 'renderStatus'>;

const ExchangeCheckoutStatus: React.FC<Props> = props => {
	const { t } = useTranslation('Exchange');
	const { status: exareStatus, onGoToTicket, passengersNames, splittedOrderId } = props;
	const { ExchangeCheckoutStatus: theme } = useTheme('Exchange');

	const { title, actionText, status, onActionClick } = useExareInfoStatus(
		'exchange',
		exareStatus,
		onGoToTicket,
		passengersNames,
		splittedOrderId
	);

	const timelimitDate =
		props.timelimit && exareStatus === ExareStatus.AwaitingPayment ? new Date(Date.parse(props.timelimit)) : null;

	if (!props.show) {
		return null;
	}

	return (
		<Notification
			className={cn(theme.wrapper, props.className)}
			type="global"
			status={status as NotificationProps['status']}
			title={title}
			text={
				!!timelimitDate && (
					<div className={theme.timelimit}>
						{t('Order must be paid by {{time}} on {{date}}', {
							time: format(timelimitDate, 'HH:mm'),
							date: format(timelimitDate, 'd MMMM yyyy')
						})}
					</div>
				)
			}
			onClickAction={onActionClick}
			actionText={actionText}
		/>
	);
};

export default ExchangeCheckoutStatus;
